export default () => ({
    root: {
        marginBottom: 25,
        width: "100%",
    },
});